export const RADIO_FIELD_CONST = {
  SIZE: {
    MEDIUM: 'medium',
    SMALL: 'small',
  },
};



// WEBPACK FOOTER //
// ./src/views/components/Common/FormMUIWrapperComponents/CustomRadioGroup/Constants.js